var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGriff = function SvgIconGriff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19.6667C13 18.0099 14.3431 16.6667 16 16.6667C17.6569 16.6667 19 18.0099 19 19.6667C19 21.3236 17.6569 22.6667 16 22.6667C14.3431 22.6667 13 21.3236 13 19.6667ZM16 20.6667C15.4477 20.6667 15 20.219 15 19.6667C15 19.1145 15.4477 18.6667 16 18.6667C16.5523 18.6667 17 19.1145 17 19.6667C17 20.219 16.5523 20.6667 16 20.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.6667C8 13.0099 9.34315 11.6667 11 11.6667H29C30.6569 11.6667 32 13.0099 32 14.6667V24.6667C32 26.3236 30.6569 27.6667 29 27.6667H11C9.34315 27.6667 8 26.3236 8 24.6667V14.6667ZM11 13.6667H29C29.5523 13.6667 30 14.1145 30 14.6667V24.6667C30 25.219 29.5523 25.6667 29 25.6667H11C10.4477 25.6667 10 25.219 10 24.6667V14.6667C10 14.1145 10.4477 13.6667 11 13.6667Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGriff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-griff.3e3bcf92.svg";
export { ForwardRef as ReactComponent };